import { icon_circle_warning } from 'components/base/images';
import { T } from 'components/common/text';
import CustomText from 'components/common/text/CustomText';
import React from 'react';
import styled from 'styled-components';

const MicrophoneAlertModal = () => {
  return (
    <StyledMicrophoneAlertModal>
      <CustomText fontSize={16} fontColor="#444" fontWeight={400} fontStyle={{ lineHeight: 24 }}>
        <T>PROJECT_MICROPHONE_ALERT_TITLE</T>
      </CustomText>
      <div className="createProjectInfo__microphone_information_box">
        <div className="createProjectInfo__microphone_information_item">
          <img src={icon_circle_warning} alt="icon_circle_warning" />
          <CustomText fontSize={16} fontColor="#444" fontWeight={400}>
            <T>PROJECT_MICROPHONE_INFORMATION_1</T>
          </CustomText>
        </div>
        <div className="createProjectInfo__microphone_information_item">
          <img src={icon_circle_warning} alt="icon_circle_warning" />
          <CustomText fontSize={16} fontColor="#444" fontWeight={400}>
            <T>PROJECT_MICROPHONE_INFORMATION_2</T>
          </CustomText>
        </div>
      </div>
    </StyledMicrophoneAlertModal>
  );
};

const StyledMicrophoneAlertModal = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  .createProjectInfo__microphone_information_box {
    display: flex;
    flex-direction: column;
    row-gap: 5px;
    .createProjectInfo__microphone_information_item {
      display: flex;
      align-items: center;
      column-gap: 5px;
    }
  }
`;

export default MicrophoneAlertModal;
